var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPingu2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9",
    "data-name": "Group 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240.943,
    height: 368.79,
    viewBox: "0 0 240.943 368.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 240.943,
    height: 368.79,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M203.355,169.151c0-.591,0-1.009,0-1.131-.138-39.93-13.967-51.111-11.069-74.815.7-5.7,2.007-16.418,9.884-25.584,6.044-7.034,14.48-9.985,22.788-11.2,14.317-2.091,28.255.978,28.919-2.807.785-4.478-17.22-13.943-35.549-14.435-1.141-.031-2.157-.023-3.016,0-5.56-5.459-23.618-21.754-50.415-22.838-6.456-.261-23.748-.96-37.919,9.911-10.707,8.213-11.209,16.57-20.037,34.687C91.6,92.418,80.792,92.49,66.438,120.621c-9.694,19-12.865,34.874-15.943,50.2C39.553,225.3,44.853,290.741,59.113,292.98c7.694,1.208,16.23-16.261,21.76-27.578,19.61-40.129,12.952-79.64,8.834-96.952",
    transform: "translate(-37.293 -7.385)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M137.279,496.1h44.813v-5.6c4.869.734,12.838,1.7,13.358,0,.476-1.557-5.25-5.5-11.419-7.325-13.852-4.095-22.791,4.619-29.947,0-2.608-1.683-5.544-5.5-5.817-15.3,41.807-41.959,66.91-100.176,65.389-171.911",
    transform: "translate(-47.593 -134.671)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M43.49,69.176c6.531,2.959,10.708,6.377,10.321,8.584-.344,1.96-4.25,2.082-9.927,2.034",
    transform: "translate(163.406 -31.476)",
    fill: "none",
    stroke: "#d9a673",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPingu2);
export default __webpack_public_path__ + "static/media/pingu2.c16b741a3ddef5b6647c2493649e8406.svg";
export { ForwardRef as ReactComponent };